// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import Table from '../Table/Table';
import { Checkboxes } from '../../../FlowConfigurationInputs';

// Import Recoil
import { initialActions, saveAvailable, changedFields, alertState } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Helpers
import { checkTheDifference, addDifference, removeDifference, CheckIfFlowUpdated } from '../../../../helpers/helper';

/**
 * @Description this page Datatable Library's Limit Rows Action configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function FindAndReplace({ action, variables, setOpenVariable, visible }) {
    const [columnType, setColumnType] = useState('');

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.';
    const l = label + 'FIND-&-REPLACE.';
    const headers = [label + "COLUMN-SELECTOR", label + "COLUMN-NAME"];

    const options = {
        tableBody: {
            headers, title: label + "COLUMN",
            customFields:
                [
                    {
                        type: 'string', title: t(l + 'FIND'), inputName: 'find', is_required: true
                    },
                    {
                        type: 'string', title: t(l + 'REPLACE'), inputName: 'replace', is_required: true
                    },
                    {
                        type: 'checkbox', title: t(l + 'CASE-SENSITIVE'), inputName: 'caseSensitive', is_required: false
                    }
                ]
        },
    };

    useEffect(() => {
        if (!action.fields.columnType) {
            action.fields.columnType = { value: 'all' }
        }

        setColumnType(action.fields.columnType.value);
    }, [action.id])

    const handleClick = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["columnType"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("columnType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
        if (value === 'select') {
            delete action.fields.find;
            delete action.fields.replace;
        }
        action.fields.columnType = { value };
        setColumnType(value);
    };

    return (
        <div>
            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t(label + 'SOURCE-DATA')} is_required />
                <VariablePicker action={action} inputName="sourceData" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>

            <div className="conf-field-container condition-tabs">
                <button className={columnType === 'all' ? 'condition-active' : ''}
                    value="all" onClick={handleClick}>
                    {t(label + 'FILL-BLANK-CELLS.ALL-COLUMN')}
                </button>
                <button className={columnType === 'select' ? 'condition-active' : ''}
                    value="select" onClick={handleClick}>
                    {t(label + 'FILL-BLANK-CELLS.SELECTED-COLUMNS')}
                </button>
            </div>

            {
                columnType === 'select' &&
                <div className="form-element">
                    <Table
                        action={action}
                        inputName="selectedColumns"
                        options={options.tableBody}
                        setOpenVariable={setOpenVariable}
                        isRequired={false}
                    />
                </div>
            }

            <div className="conf-field-container">
                <Checkboxes action={action} inputName="containsHeader" options={{ label: label + 'CONTAINS-HEADER' }} defaultValue={true} />
            </div>

            {columnType === 'all' &&
                <div>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'FIND-&-REPLACE.FIND')} is_required />
                        <TextInput action={action} inputName="find" variables={variables}
                            setOpenVariable={setOpenVariable}
                            isRequired fieldType="string" displayName={t(label + 'FIND-&-REPLACE.FIND')} hideRequired />
                    </div>

                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'FIND-&-REPLACE.REPLACE')} is_required />
                        <TextInput action={action} inputName="replace" variables={variables}
                            setOpenVariable={setOpenVariable}
                            isRequired fieldType="string" displayName={t(label + 'FIND-&-REPLACE.REPLACE')} hideRequired />
                    </div>

                    <div className="conf-field-container">
                        <Checkboxes action={action} inputName="caseSensitive" options={{ label: l + 'CASE-SENSITIVE' }} />
                    </div>
                </div>
            }

        </div>
    )
}